import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  to?: string;
  toLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  to,
  toLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-600">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="text-lg md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && (
            <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {to && (
        <Link
          to={to}
          className="flex items-center gap-1 text-xs md:text-sm text-accent-600 hover:text-accent-700 whitespace-nowrap cursor-pointer transition-colors"
        >
          <span>{toLabel}</span>
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}